import { showErrorAxios } from "infra/helpers/alerta";
import http from "infra/http";
import { useMutation, useQueryClient } from "react-query";

interface UseFecharRateioProps {
  id?: string;
  year: string;
  month: string;
}
const getRoute = ({id, year, month}: UseFecharRateioProps) => `/v1/rateio/${id}/${year}/${month}/fechar`;

function useFecharRateio({id, year, month, onSuccess}: UseFecharRateioProps & {onSuccess?: () => any}) {
  const queryClient = useQueryClient();

  return useMutation(
    "fechar/v1/rateio/:year/:month/:id",
    (_id?: string | undefined) => http.post(getRoute({id: _id || id, year, month})),
    {
      retry: false,
      onSuccess: (_, _id) => {
        queryClient.invalidateQueries("/v1/rateio");
        queryClient.invalidateQueries(`/v1/rateio/${_id || id}/${year}/${month}/contas`);
        onSuccess?.();
      },
      onError: (e) => {
        showErrorAxios(e)
      }
    }
  );
}

export default useFecharRateio;
